import { getIn } from 'formik';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { ISettingsFlowersMailForm } from './types';
import Input from 'components/base/Input';

export const SettingsFlowerMailForm: FC<ISettingsFlowersMailForm> = ({
  value, handleBlur, onChange, errors,
}) => {
  const { t } = useTranslation();

  return (
    <div className="form-generator">
      <Input
        checked={value?.automationMailFlowersEnabled}
        error={getIn(errors, 'mailFlowersSettingsDto.automationMailFlowersEnabled')}
        id="automationMailFlowersEnabled"
        name="automationMailFlowersEnabled"
        placeholder={t('common.active')}
        type="checkbox"
        onBlur={handleBlur}
        onChange={(val) => {
          onChange({
            ...value,
            automationMailFlowersEnabled: !!val,
          });
        }}
      />
      <Input
        disabled={!value.automationMailFlowersEnabled}
        error={getIn(errors, 'mailFlowersSettingsDto.automationMailFlowersDelay')}
        id="deplay"
        min={1}
        name="deplay"
        placeholder={t('settings.flowersMail.delay')}
        type="number"
        value={value?.automationMailFlowersDelay || ''}
        onChange={(val: string) => onChange({
          ...value,
          automationMailFlowersDelay: Number(val),

        })}
      />
    </div>
  );
};
